export default __webpack_public_path__ + "static/media/Arrendamiento.64c5f1fe.svg";